export const USER_ROLES = {
  ACCOUNT_HOLDER: "account_holder",
  ADMIN: "admin",
  MAINTAINER: "maintainer",
  LEVI_MAINTAINER: "levi_maintainer"
} as const

export type UserRole = (typeof USER_ROLES)[keyof typeof USER_ROLES]
